import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import Header from "./components/Header";
import Hero from "./components/Hero";
import VehiclesList from "./components/VehiclesList";
import WhyChooseUs from "./components/WhyChooseUs";
import HowItWorks from "./components/HowItWorks";
import WhatsIncluded from "./components/WhatsIncluded";
import ForTourists from "./components/ForTourists";
import Requirements from "./components/Requirements";
import Testimonials from "./components/Testimonials";
import FAQ from "./components/FAQ";
import PaymentMethods from "./components/PaymentMethods";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import VehicleDetail from "./components/VehicleDetail";
import MetaPixel from "./components/MetaPixel";
import GoogleAnalytics from "./components/GoogleAnalytics";
import PromoPopup from "./components/PromoPopup";

function HomePage() {
  return (
    <>
      <Hero />
      <VehiclesList />
      <Requirements />
      <WhatsIncluded />
      <FAQ />
      <Testimonials />
      <PaymentMethods />
      <Contact />
    </>
  );
}

function App() {
  // Replace with your actual IDs from:
  // - Meta Business Manager > Events Manager (Meta Pixel ID)
  // - Google Analytics > Admin > Property > Data Streams (Measurement ID format: G-XXXXXXXXXX)
  const metaPixelId = process.env.REACT_APP_META_PIXEL_ID || '';
  const googleAnalyticsId = process.env.REACT_APP_GA_MEASUREMENT_ID || '';

  return (
    <BrowserRouter>
      <div className="App">
        {/* Analytics */}
        {metaPixelId && <MetaPixel pixelId={metaPixelId} />}
        {googleAnalyticsId && <GoogleAnalytics measurementId={googleAnalyticsId} />}
        
        {/* Promo Popup - Only on home page */}
        <Routes>
          <Route path="/" element={<PromoPopup />} />
        </Routes>
        
        {/* Header - Always visible */}
        <Header />
        
        {/* Routes */}
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/vehiculo/:id" element={<VehicleDetail />} />
        </Routes>
        
        {/* Footer - Always visible */}
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
